import { render, staticRenderFns } from "./ProjectStatusBar.vue?vue&type=template&id=258f321a&"
import script from "./ProjectStatusBar.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatusBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports